import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { UserAgent } from '@mirinae/js-utils';

import TextAudio from '@mirinae/lessons/components/lesson/elements/TextAudio';
import PageElements from '@mirinae/lessons/components/lesson/PageElements';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { PageTop } from './DefaultPage';

const isMobile = !UserAgent.os.isOthers;

const ConversationStack = styled(Element)`
    ${isMobile ? (`
    `) : (`
    `)};
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
`;

const LessonGoalWithImage = ({ page }) => {
    const [audioTexts, setAudioTexts] = useState([]);

    useEffect(() => {
        const texts = [];
        page.children.forEach(step => step.children.filter(e => e.type === 'conversationAudio').forEach(e => {
            e.layout = { margin: { left: 10, top: 0 } };
            texts.push(e);
        }));
        if (texts.length > 0) {
            setAudioTexts(texts);
        }
    }, []);

    const SentencesBox = ({ element }) => (
        <ConversationStack element={element}>
            { audioTexts.map((e, i) => (
                <TextAudio key={i} element={e} />
            ))}
        </ConversationStack>
    );

    return (
        <>
            <PageTop page={page} />
            <PageElements
                page={page} except={['continueButton', 'conversationAudio']}
                mapComponent={e => e.name === 'sentencesBox' && SentencesBox} />
        </>
    );
};

export default LessonGoalWithImage;
